module.exports = __webpack_public_path__ + "static/media/navbar-extra-shape-onoiwa.6a90e4c3.png";